import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NorthWestIcon(props: IconProps) {
    return <Icon {...props} iconKey={"north_west"}/>
}
